import { getAverageVector, getForwardDirection, getRobotPositions } from "./positionData"
import * as T from 'three';
import { getBestPlane } from "./plane";

/**
 * 
 * @param {PlaneData} planeData Plane center and forward direction
 * @param {number} distance Distance from the plane
 * @returns {[THREE.Vector3, THREE.Vector3]} Position and of camera and LookAt point
 */
export function getViewPointFromPlane(planeData, distance) {
    let pos = planeData.point
    let norm = planeData.normal
    if(norm.y < 0) {
        norm.divideScalar(-1)
    }
    norm.normalize()
    norm.multiplyScalar(distance)
    let viewPoint = new T.Vector3()
    viewPoint.addVectors(pos, norm)
    return [pos, viewPoint]
}

/**
 * Takes a robot's 
 * @param {RobotGroup} robotGroup RobotGroup 
 * @param {Array[number]} times Times to of positions
 * @returns 
 */
export function getAverageForwardDirection(robotGroup, times) {
    let basePoses = []
    let forwardPoses = []
    times.forEach(time => {
        robotGroup.animationInterface.updateTime(time, true)
        let pair = getForwardDirection(robotGroup)
        basePoses.push(pair[0])
        forwardPoses.push(pair[1])
    })

    let avgBase = getAverageVector(basePoses)
    let avgForward = getAverageVector(forwardPoses)

    return [avgBase, avgForward]
}

export function getPoseCollisionDirection(robotGroup, times) {
    let collisionGroups = getRobotPositions(robotGroup, times)

    let collisionPoints = []
    collisionGroups.forEach(group => {
        group[1].forEach(pos => {
            collisionPoints.push(pos)
        })
    })
    if(collisionPoints.length < 3) {
        return [null, null]
    } else {
        let posePlaneData = getBestPlane(collisionPoints)
        return getViewPointFromPlane(posePlaneData, 2.5)
    }
}

export function getMotionPlaneDirection(motionPlaneData) {
    return getViewPointFromPlane(motionPlaneData, 2.5)
}

export function getJointPlaneDirection(robotGroup) {
    let positionVectors = []
    let positionMatrix = []

    robotGroup.jointInterface.getJoints().forEach(joint => {
        let pos = joint[1].getWorldPosition(new T.Vector3);
        positionVectors.push(pos)
        positionMatrix.push([pos.x, pos.y, pos.z])
    })

    if(positionVectors.length < 3) {
        return [null, null]
    }
    else {
        let planeData = getBestPlane(positionVectors, false)
        return getViewPointFromPlane(planeData, 2.5)
    }
}

// heuristics are [[lookAtPoints], [lookFromPoints]]
// weights are [[lookAtWeights], [lookFromWeights]]
export function combineHeuristics(heuristics, weights) {
    if(heuristics[0].length != weights[0].length || heuristics[1].length != weights[1].length) {
        console.error("Mismatch number of heuristics and weights")
        return;
    }

    let w1Sum = 0
    let w2Sum = 0
    weights[0].forEach(w => {
        w1Sum += w
    })
    weights[1].forEach(w => {
        w2Sum += w
    })

    let lookAt = [0, 0, 0]
    let lookFrom = [0, 0, 0]

    for(let i = 0; i < heuristics[0].length; i++) {

        console.log(heuristics[0][i], heuristics[1][i])

        if(!(heuristics[0][i] == null || heuristics[1][i] == null)) {

            console.log(heuristics[0][i], heuristics[1][i], weights[0][i], weights[1][i])

            lookAt[0] += heuristics[0][i].x * weights[0][i]
            lookAt[1] += heuristics[0][i].y * weights[0][i]
            lookAt[2] += heuristics[0][i].z * weights[0][i]
    
            lookFrom[0] += heuristics[1][i].x * weights[1][i]
            lookFrom[1] += heuristics[1][i].y * weights[1][i]
            lookFrom[2] += heuristics[1][i].z * weights[1][i]

        }
    }

    let lookAtVector = new T.Vector3(lookAt[0], lookAt[1], lookAt[2])
    let lookFromVector = new T.Vector3(lookFrom[0], lookFrom[1], lookFrom[2])

    lookAtVector.divideScalar(w1Sum)
    lookFromVector.divideScalar(w2Sum)

    return [lookAtVector, lookFromVector]
}

export function extendViewDistance(lookAt, lookFrom, distance) {
    let viewPoint = new T.Vector3()
    viewPoint.subVectors(lookFrom, lookAt)
    viewPoint.normalize()
    viewPoint.multiplyScalar(distance)
    viewPoint.add(lookAt)

    return [lookAt, viewPoint]
}